import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Platforms from "@/components/landing/Platforms";
import RegistrationForm from "@/components/landing/RegistrationForm";
import Stats from "@/components/landing/Stats";
import HowItWorks from "@/components/landing/HowItWorks";
import WhyUs from "@/components/landing/WhyUs";
import Services from "@/components/landing/Services";
import Pricing from "@/components/landing/Pricing";
import Royalty from "@/components/landing/Royalty";
import RoyaltyPricing from "@/components/landing/RoyaltyPricing";
import Licensing from "@/components/landing/Licensing";
import Revenue from "@/components/landing/Revenue";
import WhoFor from "@/components/landing/WhoFor";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div className="relative min-h-screen bg-[#05050A] text-white overflow-hidden">
      {/* Ambient background glows */}
      <div aria-hidden className="pointer-events-none fixed inset-0 z-0">
        <div className="absolute top-[-10%] left-[-10%] w-[40rem] h-[40rem] rounded-full bg-purple-700/20 blur-[160px] pulse-glow" />
        <div className="absolute top-[40%] right-[-10%] w-[36rem] h-[36rem] rounded-full bg-cyan-500/15 blur-[160px] pulse-glow" />
        <div className="absolute bottom-[-10%] left-[20%] w-[36rem] h-[36rem] rounded-full bg-indigo-600/15 blur-[160px] pulse-glow" />
      </div>

      <div className="relative z-10">
        <Header />
        <main>
          <Hero />
          <Platforms />
          <RegistrationForm />
          <Stats />
          <HowItWorks />
          <WhyUs />
          <Services />
          <Pricing />
          <Royalty />
          <RoyaltyPricing />
          <Licensing />
          <Revenue />
          <WhoFor />
          <FAQ />
          <FinalCTA />
        </main>
        <Footer />
      </div>
    </div>
  );
}
